"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClaimsList = void 0;
/**
 * Retrieves a list of claims from the provided response data.
 * @param responseData The response data containing the claims.
 * @returns An array of claims.
 */
const getClaimsList = (responseData) => {
    const claimsList = responseData
        .map((r) => {
        const { claimData } = r;
        if (claimData) {
            for (const key of Object.keys(claimData)) {
                for (const subkey of Object.keys(claimData[key])) {
                    if (typeof claimData[key][subkey] == 'string') {
                        claimData[key][subkey] = claimData[key][subkey].replaceAll('"', '');
                    }
                }
            }
            return claimData;
        }
        return null;
    })
        .filter((item) => item !== null);
    return claimsList;
};
exports.getClaimsList = getClaimsList;
//# sourceMappingURL=get-claims-list.js.map